/** Faixa de score alinhada ao sistema ECP (exibição quando não há scoreClassification). */
export function scoreToClassification(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return null;
  if (n >= 76) return "EXCEPCIONAL";
  if (n >= 66) return "PROVÁVEL";
  if (n >= 41) return "POSSÍVEL";
  if (n >= 11) return "REMOTO";
  return "INAPTO";
}

export function mapDjePublicationToListItem(pub, { isOrigin = false } = {}) {
  const id = pub.id || pub._id;
  const sortDate = pub.dataDisponibilizacao
    ? new Date(pub.dataDisponibilizacao)
    : null;

  return {
    id,
    isOrigin,
    score: pub.score ?? 0,
    scoreClassification: scoreToClassification(pub.score),
    sortDate,
    datePublication: pub.dataDisponibilizacao,
    tribunal: pub.tribunal || pub.siglaTribunal,
    source: pub.tipoComunicacao || pub.tipoDocumento || "DJE Comunica",
    summary: pub.resumo || pub.resumoIa,
    content: pub.texto || pub.conteudo,
    classifications: pub.classifications || [],
    raw: pub,
  };
}

/**
 * Ordena publicações DJE: origem do processo primeiro, depois data decrescente.
 */
export function sortProcessPublications(items = []) {
  const byKey = new Map();

  for (const item of items) {
    if (!item?.id) continue;
    const key = item.id;
    const existing = byKey.get(key);
    if (existing) {
      if (item.isOrigin) {
        byKey.set(key, { ...existing, isOrigin: true });
      }
      continue;
    }
    byKey.set(key, item);
  }

  return Array.from(byKey.values()).sort((a, b) => {
    if (a.isOrigin && !b.isOrigin) return -1;
    if (!a.isOrigin && b.isOrigin) return 1;
    const ta = a.sortDate?.getTime?.() ?? 0;
    const tb = b.sortDate?.getTime?.() ?? 0;
    return tb - ta;
  });
}

export function getProcessNumberDigits(processo) {
  const raw =
    processo?.numeroProcesso ||
    processo?.judgment?.number ||
    "";
  return String(raw).replace(/[^0-9]/g, "");
}
